import { render, staticRenderFns } from "./AppSideNav.vue?vue&type=template&id=04235d47&scoped=true&"
import script from "./AppSideNav.vue?vue&type=script&lang=js&"
export * from "./AppSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AppSideNav.vue?vue&type=style&index=0&id=04235d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04235d47",
  null
  
)

export default component.exports